<script>
import FileReaderUtils from '@/utils/fileReaderUtils'
import LabelledBorder from '@/components/LabelledBorder'
import Vue from 'vue'

export default
{
    name: 'file-upload-zone',

    props:
    {
        label: { type: String, default: 'Choisissez des fichiers à envoyer' },
        accept: { type: String, default: '*' },
        maxFileCount: { type: Number, default: 1 },

        validation: { type: Number, default: 0 },
    },

    created ()
    {
    },

    render () 
    {
        const showAddButton = this.filesUploadedPreviews.length < this.maxFileCount

        return (
            <div class='file-upload-zone'>
                <labelled-border ref='labelledBorder' label-retracted={this.filesUploadedPreviews.length > 0}>
                    <div class='container' on-click={this.onContainerClicked}>
                        {
                            this.filesUploadedPreviews.map((preview, index) =>
                            {
                                const onlyChild = this.filesUploadedPreviews.length == 1 && !showAddButton

                                return <img src={preview} class={`file-preview ${onlyChild ? 'single' : ''}`}
                                    on-click={() => this.onFilePreviewClicked(index)} />
                            })
                        }
                        <div class='add-file-btn' v-show={showAddButton} on-click={this.onAddFileButtonClicked}>
                            <inline-svg src={require('@/assets/img/plus.svg')} />
                        </div>
                        <div class='label'>{ this.label }</div>
                    </div>
                </labelled-border>
                <input type='file' multiple ref='uploadInput' on-change={this.onInputFilesChanged} style={{ display: 'none' }} />
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
            filesUploaded: {},
            filesUploadedPreviews: []
        }
    },

    computed:
    {
        filesUploadedCount ()
        {
            return Object.keys(this.filesUploaded).length
        },
    },

    watch:
    {
        filesUploaded ()
        {
            this.$emit('input', Object.values(this.filesUploaded))
        }
    },

    methods:
    {
        onContainerClicked (e)
        {
        },
        onAddFileButtonClicked ()
        {
            this.$refs.uploadInput.click()
        },

        async onInputFilesChanged ()
        {
            for (let file of this.$refs.uploadInput.files)
            {
                await this.addToUploadedFiles(file)
            }

            const filesOverflow = this.filesUploadedCount - this.maxFileCount
            if (filesOverflow > 0)
            {
                for (let i = 0; i < filesOverflow; i++)
                {
                    this.removeUploadFileAtIndex(0)
                }
            }

            this.$refs.uploadInput.value = ''
        },

        onFilePreviewClicked (index)
        {
            this.removeUploadFileAtIndex(index)
        },

        removeUploadFileAtIndex (index)
        {
            Vue.delete(this.filesUploaded, Object.keys(this.filesUploaded)[index])
            this.filesUploadedPreviews.splice(index, 1)
        },

        async addToUploadedFiles (file)
        {
            const getFileId = file => file.name + file.lastModified + file.size + file.type

            if (typeof file == 'string' && file.startsWith('http'))
            {
                Vue.set(this.filesUploaded, file, file)
                this.filesUploadedPreviews.push(file)
            }
            else
            {
                const type = file.type.split('/').pop().split('+')[0]
                if (this.accept != '*' && !this.accept.includes(type))
                {
                    return this.$toast.warning(`Ce format de fichier n\'est pas supporté (${file.type})`)
                }

                const id = getFileId(file)
                if (this.filesUploaded[id]) return
                Vue.set(this.filesUploaded, id, await FileReaderUtils.readAsDataURLAsync(file))
                this.filesUploadedPreviews.push(this.filesUploaded[id])
            }
        },

        setErrorMessage (message)
        {
            this.$refs.labelledBorder.errorMessage = message
        }
    },

    components:
    {
        LabelledBorder
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.file-upload-zone
{
    .labelled-border .content
    {
        padding-top: 5px;
        padding-bottom: 5px;

        border: 2px solid transparent;
        border-radius: 8px;
        
        & .border
        {
            border-color: var(--theme-border-color);
        }

        .container
        {
            display: flex;
            flex-flow: row wrap;
            align-items: center;
            padding: 2px 10px;

            > .add-file-btn, .file-preview
            {
                border-radius: 10px;
                cursor: pointer;
                height: 70px;
                margin: 4px;
                width: 30%;

                .OnDesktop({
                    margin: 10px;
                    width: 20%;
                });
            }

            > .file-preview
            {
                object-fit: cover;

                &.single
                {
                    width: 100%;
                }
            }

            > .add-file-btn
            {
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: var(--theme-background-text-color-soft);
                transition: all 0.1s ease-out;

                &:first-child
                {
                    height: 50px;
                    width: 70px;

                    .OnDesktop({
                        width: 80px;
                        height: 40px;
                    });
                }

                &:active
                {
                    background-color: var(--theme-background-text-color-heavy);
                }
                
                > svg
                {
                    fill: var(--theme-background-text-color-heavy);
                    .WidthHeight(50%);

                    .OnDesktop({ .WidthHeight(40%); });
                }
            }

            > .label
            {
                font-size: 90%;
                color: var(--theme-text-color-extra-light);
                margin-left: 10px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/FileUploadZone.vue